import { Component } from "@theme/component";
class VolumePricingComponent extends Component {
  /**
   * Toggles the expanded state of the volume pricing table
   */
  toggleExpanded() {
    this.classList.toggle("volume-pricing--expanded");
  }
}
if (!customElements.get("volume-pricing")) {
  customElements.define("volume-pricing", VolumePricingComponent);
}
